{ "closeAria": "Chiudi", "historyAria": "Cronologia delle richieste", "supportTitle": "Assistenza" }
